<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<ng-container *transloco="let t">
  <nav
    *ngIf="availableFilters$ | async"
    class="phone-filters-sidebar"
    [class.compact]="(lessThan$ | async)?.lg === true">
    <span class="fixed-space-8" aria-hidden="true"></span>
    <span class="line"></span>

    <h2 class="title">{{ t('sidebar_filter_title') }}</h2>
    <span class="fixed-space-16" aria-hidden="true"></span>

    <span class="clear" (click)="clearFilters()"> {{ t('tooltip_clear_filters') }} </span>
    <span class="fixed-space-16" aria-hidden="true"></span>

    <!-- Price -->
    <div
      class="flex justify-between align-base pointer"
      (click)="filterCollapsed['price'] = !filterCollapsed['price']">
      <h3 class="title">{{ t('filter_title_price') }}</h3>
      <popsy-icon-add *ngIf="filterCollapsed['price']" class="icon"></popsy-icon-add>
      <popsy-icon-arrow-up-1
        *ngIf="!filterCollapsed['price']"
        class="icon"></popsy-icon-arrow-up-1>
    </div>
    <span class="fixed-space-16" aria-hidden="true"></span>
    <popsy-phone-price-filter
      *ngIf="!filterCollapsed['price']"
      [minPrice]="phoneFilterOptions?.minPrice"
      [maxPrice]="phoneFilterOptions?.maxPrice"
      [currency]="phoneFilterOptions?.currency"
      [loading]="loading"
      (debouncedPriceRangeChange)="onPriceRangeChange($event)"></popsy-phone-price-filter>
    <span *ngIf="filterCollapsed['price']" class="line" aria-hidden="true"></span>
    <span class="fixed-space-16" aria-hidden="true"></span>

    <!-- Brand -->
    <div
      class="flex justify-between align-base pointer"
      (click)="filterCollapsed['brand'] = !filterCollapsed['brand']">
      <h3 class="title">{{ t('spec_brand') }}</h3>
      <popsy-icon-add *ngIf="filterCollapsed['brand']" class="icon"></popsy-icon-add>
      <popsy-icon-arrow-up-1
        *ngIf="!filterCollapsed['brand']"
        class="icon"></popsy-icon-arrow-up-1>
    </div>
    <span class="fixed-space-16" aria-hidden="true"></span>
    <popsy-product-brand-filter
      *ngIf="!filterCollapsed['brand']"
      [loading]="loading"
      [searchOptionsPath]="searchOptionsPath"
      [selected]="phoneFilterOptions?.brands"
      (selectionChanged)="onProductBrandChanged($event)"></popsy-product-brand-filter>
    <span *ngIf="filterCollapsed['brand']" class="line" aria-hidden="true"></span>
    <span class="fixed-space-16" aria-hidden="true"></span>

    <!-- Series-->
    <ng-container *ngIf="(availableFilters$ | async)?.series?.length">
      <div
        class="flex justify-between align-base pointer"
        (click)="filterCollapsed['series'] = !filterCollapsed['series']">
        <h3 class="title">{{ t('spec_series') }}</h3>
        <popsy-icon-add *ngIf="filterCollapsed['series']" class="icon"></popsy-icon-add>
        <popsy-icon-arrow-up-1
          *ngIf="!filterCollapsed['series']"
          class="icon"></popsy-icon-arrow-up-1>
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <popsy-product-series-filter
        *ngIf="!filterCollapsed['series']"
        [loading]="loading"
        [searchOptionsPath]="searchOptionsPath"
        [selected]="phoneFilterOptions?.series"
        (selectionChanged)="onPhoneSeriesChanged($event)"></popsy-product-series-filter>
      <span *ngIf="filterCollapsed['series']" class="line" aria-hidden="true"></span>
      <span class="fixed-space-16" aria-hidden="true"></span>
    </ng-container>

    <!-- Model -->
    <div
      class="flex justify-between align-base pointer"
      (click)="filterCollapsed['model'] = !filterCollapsed['model']">
      <h3 class="title">{{ t('spec_model') }}</h3>
      <popsy-icon-add *ngIf="filterCollapsed['model']" class="icon"></popsy-icon-add>
      <popsy-icon-arrow-up-1
        *ngIf="!filterCollapsed['model']"
        class="icon"></popsy-icon-arrow-up-1>
    </div>
    <span class="fixed-space-16" aria-hidden="true"></span>
    <popsy-phone-model-filter
      *ngIf="!filterCollapsed['model']"
      [loading]="loading"
      [searchOptionsPath]="searchOptionsPath"
      [selected]="phoneFilterOptions?.models"
      (selectionChanged)="onPhoneModelChanged($event)"></popsy-phone-model-filter>
    <span *ngIf="filterCollapsed['model']" class="line" aria-hidden="true"></span>
    <span class="fixed-space-16" aria-hidden="true"></span>

    <!-- Color -->
    <div
      class="flex justify-between align-base pointer"
      (click)="filterCollapsed['color'] = !filterCollapsed['color']">
      <h3 class="title">{{ t('spec_color') }}</h3>
      <popsy-icon-add *ngIf="filterCollapsed['color']" class="icon"></popsy-icon-add>
      <popsy-icon-arrow-up-1
        *ngIf="!filterCollapsed['color']"
        class="icon"></popsy-icon-arrow-up-1>
    </div>
    <span class="fixed-space-16" aria-hidden="true"></span>
    <popsy-phone-color-filter
      *ngIf="!filterCollapsed['color']"
      [loading]="loading"
      [searchOptionsPath]="searchOptionsPath"
      [selected]="phoneFilterOptions?.colors"
      (selectionChanged)="onPhoneColorChanged($event)"></popsy-phone-color-filter>
    <span *ngIf="filterCollapsed['color']" class="line" aria-hidden="true"></span>
    <span class="fixed-space-16" aria-hidden="true"></span>

    <!-- Storage -->
    <ng-container *ngIf="(availableFilters$ | async)?.storage?.length">
      <div
        class="flex justify-between align-base pointer"
        (click)="filterCollapsed['storage'] = !filterCollapsed['storage']">
        <h3 class="title">{{ t('spec_storage') }}</h3>
        <popsy-icon-add *ngIf="filterCollapsed['storage']" class="icon"></popsy-icon-add>
        <popsy-icon-arrow-up-1
          *ngIf="!filterCollapsed['storage']"
          class="icon"></popsy-icon-arrow-up-1>
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <popsy-phone-storage-filter
        *ngIf="!filterCollapsed['storage']"
        [loading]="loading"
        [searchOptionsPath]="searchOptionsPath"
        [selected]="phoneFilterOptions?.storages"
        (selectionChanged)="onPhoneStorageChanged($event)"></popsy-phone-storage-filter>
      <span *ngIf="filterCollapsed['storage']" class="line" aria-hidden="true"></span>
      <span class="fixed-space-16" aria-hidden="true"></span>
    </ng-container>

    <!-- Cpu -->
    <ng-container *ngIf="(availableFilters$ | async)?.cpu?.length">
      <div
        class="flex justify-between align-base pointer"
        (click)="filterCollapsed['cpu'] = !filterCollapsed['cpu']">
        <h3 class="title">{{ t('spec_cpu') }}</h3>
        <popsy-icon-add *ngIf="filterCollapsed['cpu']" class="icon"></popsy-icon-add>
        <popsy-icon-arrow-up-1
          *ngIf="!filterCollapsed['cpu']"
          class="icon"></popsy-icon-arrow-up-1>
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <popsy-product-cpu-filter
        *ngIf="!filterCollapsed['cpu']"
        [loading]="loading"
        [searchOptionsPath]="searchOptionsPath"
        [selected]="phoneFilterOptions?.cpu"
        (selectionChanged)="onProductCpuChanged($event)"></popsy-product-cpu-filter>
      <span *ngIf="filterCollapsed['cpu']" class="line" aria-hidden="true"></span>
      <span class="fixed-space-16" aria-hidden="true"></span>
    </ng-container>

    <!-- Graphics -->
    <ng-container *ngIf="(availableFilters$ | async)?.graphics?.length">
      <div
        class="flex justify-between align-base pointer"
        (click)="filterCollapsed['graphics'] = !filterCollapsed['graphics']">
        <h3 class="title">{{ t('spec_graphics') }}</h3>
        <popsy-icon-add *ngIf="filterCollapsed['graphics']" class="icon"></popsy-icon-add>
        <popsy-icon-arrow-up-1
          *ngIf="!filterCollapsed['graphics']"
          class="icon"></popsy-icon-arrow-up-1>
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <popsy-product-graphics-filter
        *ngIf="!filterCollapsed['graphics']"
        [loading]="loading"
        [searchOptionsPath]="searchOptionsPath"
        [selected]="phoneFilterOptions?.graphics"
        (selectionChanged)="
          onProductGraphicsChanged($event)
        "></popsy-product-graphics-filter>
      <span *ngIf="filterCollapsed['graphics']" class="line" aria-hidden="true"></span>
      <span class="fixed-space-16" aria-hidden="true"></span>
    </ng-container>

    <!-- launch_date -->
    <ng-container *ngIf="(availableFilters$ | async)?.launch_date?.length">
      <div
        class="flex justify-between align-base pointer"
        (click)="filterCollapsed['launch_date'] = !filterCollapsed['launch_date']">
        <h3 class="title">{{ t('spec_launch_date') }}</h3>
        <popsy-icon-add
          *ngIf="filterCollapsed['launch_date']"
          class="icon"></popsy-icon-add>
        <popsy-icon-arrow-up-1
          *ngIf="!filterCollapsed['launch_date']"
          class="icon"></popsy-icon-arrow-up-1>
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <popsy-product-launch-date-filter
        *ngIf="!filterCollapsed['launch_date']"
        [loading]="loading"
        [searchOptionsPath]="searchOptionsPath"
        [selected]="phoneFilterOptions?.launch_date"
        (selectionChanged)="
          onProductLaunchDateChanged($event)
        "></popsy-product-launch-date-filter>
      <span *ngIf="filterCollapsed['launch_date']" class="line" aria-hidden="true"></span>
      <span class="fixed-space-16" aria-hidden="true"></span>
    </ng-container>

    <!-- ram -->
    <ng-container *ngIf="(availableFilters$ | async)?.ram?.length">
      <div
        class="flex justify-between align-base pointer"
        (click)="filterCollapsed['ram'] = !filterCollapsed['ram']">
        <h3 class="title">{{ t('spec_ram') }}</h3>
        <popsy-icon-add *ngIf="filterCollapsed['ram']" class="icon"></popsy-icon-add>
        <popsy-icon-arrow-up-1
          *ngIf="!filterCollapsed['ram']"
          class="icon"></popsy-icon-arrow-up-1>
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <popsy-product-ram-filter
        *ngIf="!filterCollapsed['ram']"
        [loading]="loading"
        [searchOptionsPath]="searchOptionsPath"
        [selected]="phoneFilterOptions?.ram"
        (selectionChanged)="onProductRamChanged($event)"></popsy-product-ram-filter>
      <span *ngIf="filterCollapsed['ram']" class="line" aria-hidden="true"></span>
      <span class="fixed-space-16" aria-hidden="true"></span>
    </ng-container>

    <!-- screen_size -->
    <ng-container *ngIf="(availableFilters$ | async)?.screen_size?.length">
      <div
        class="flex justify-between align-base pointer"
        (click)="filterCollapsed['screen_size'] = !filterCollapsed['screen_size']">
        <h3 class="title">{{ t('spec_screen_size') }}</h3>
        <popsy-icon-add
          *ngIf="filterCollapsed['screen_size']"
          class="icon"></popsy-icon-add>
        <popsy-icon-arrow-up-1
          *ngIf="!filterCollapsed['screen_size']"
          class="icon"></popsy-icon-arrow-up-1>
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <popsy-product-screen-filter
        *ngIf="!filterCollapsed['screen_size']"
        [loading]="loading"
        [searchOptionsPath]="searchOptionsPath"
        [selected]="phoneFilterOptions?.screen_size"
        (selectionChanged)="
          onProductScreenSizeChanged($event)
        "></popsy-product-screen-filter>
      <span *ngIf="filterCollapsed['screen_size']" class="line" aria-hidden="true"></span>
      <span class="fixed-space-16" aria-hidden="true"></span>
    </ng-container>

    <!-- storage_type -->
    <ng-container *ngIf="(availableFilters$ | async)?.storage_type?.length">
      <div
        class="flex justify-between align-base pointer"
        (click)="filterCollapsed['storage_type'] = !filterCollapsed['storage_type']">
        <h3 class="title">{{ t('spec_storage_type') }}</h3>
        <popsy-icon-add
          *ngIf="filterCollapsed['storage_type']"
          class="icon"></popsy-icon-add>
        <popsy-icon-arrow-up-1
          *ngIf="!filterCollapsed['storage_type']"
          class="icon"></popsy-icon-arrow-up-1>
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <popsy-product-storage-type-filter
        *ngIf="!filterCollapsed['storage_type']"
        [loading]="loading"
        [searchOptionsPath]="searchOptionsPath"
        [selected]="phoneFilterOptions?.storage_type"
        (selectionChanged)="
          onProductStorageTypeChanged($event)
        "></popsy-product-storage-type-filter>
      <span class="fixed-space-16" aria-hidden="true"></span>
    </ng-container>
  </nav>
</ng-container>
